var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMediaDuplicate = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43115 2.33977C3.43115 1.60064 4.02426 1 4.75413 1H9.40787C10.1377 1 10.7308 1.60065 10.7308 2.33977V7.72973C10.7308 8.46885 10.1377 9.0695 9.40787 9.0695H4.75413C4.02426 9.0695 3.43115 8.46886 3.43115 7.72973V2.33977ZM1.5 3.4051C1.5 3.17094 1.68744 2.98112 1.91867 2.98112C2.14989 2.98112 2.33734 3.17094 2.33734 3.4051V9.66023C2.33734 9.92281 2.54961 10.152 2.79798 10.152H8.35582C8.58707 10.152 8.77454 10.3418 8.77454 10.576C8.77454 10.8102 8.58707 11 8.35582 11H2.82298C2.09312 11 1.5 10.3994 1.5 9.66023V3.4051Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMediaDuplicate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-media-duplicate.57c5c6955eaab7279ef409f0591f83a3.svg";